import {Component, Input, OnInit} from "@angular/core";
import {DialogComponent} from "../../../ng2-bootstrap-modal/dialog.component";
import {DialogService} from "../../../ng2-bootstrap-modal/dialog.service";
import {UserSubscriptionType, UserSubscriptionIds, UserSubscription} from "../../user/user-subscription";
import {Router} from "@angular/router";
import {Website} from "../website/website";
import * as fromStore from '../../store';
import {Store} from '@ngrx/store';
import {filter, first, switchMap} from "rxjs/operators";
import {ActivityAction} from "../../activities/activity";
import {Product} from "../website/product";
import {PerformanceService} from "../website/performance/performance.service";
import {Config} from "../../config/config";
import {DbResponse} from "../../shared/interceptors/db-response";
import {ProductService} from "../website/product.service";
declare var FB: any;

@Component({
    selector: 'db-from-manager-dialog',
    templateUrl: 'from-manager-dialog.component.html',
    styleUrls: ['from-manager-dialog.component.scss'],
    standalone: false
})
export class FromManagerDialogComponent extends DialogComponent<null, boolean> implements OnInit {

  @Input() websiteId: number;
  @Input() currentSubscriptionType: string;
  @Input() fromPluginId: number;
  @Input() userSubscription?: UserSubscription;
  public website: Website;
  public challengeDialog: boolean;
  public premiumPlugin: Product;
  public elementorPlugin: Product;
  public fromPremiumPlugin: boolean = false;
  public UserSubscriptionType: any = UserSubscriptionType;
  public UserSubscriptionIds: any = UserSubscriptionIds;

  constructor(
    private _router: Router,
    private _store: Store<fromStore.DbStoreState>,
    private _performanceService: PerformanceService,
    private _dialogService: DialogService,
    private _productService: ProductService,
  ) {
    super(
      _dialogService
    );
  }

  ngOnInit(): void {
    this.getElementorPlugin();
    this._performanceService.getGooglePageSpeedScore(this.websiteId);
    this.challengeDialog = this.currentSubscriptionType === UserSubscriptionType.FREE && this.fromPluginId === 181;

    this._store.select(fromStore.getTenWebProductsLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        first()
      )
      .subscribe(() => {
        this._store.select(fromStore.getTenWebProducts)
          .pipe(first())
          .subscribe((products: any[]) => {
            this.premiumPlugin = this.fromPluginId ? (products.find((product: Product) => product.productId === this.fromPluginId)) : null;
          });
      });
    const servicesList = [69, 167, 171, 71, 165];
    this.fromPremiumPlugin = this.fromPluginId && this.currentSubscriptionType === UserSubscriptionType.ONE_PRODUCT && !servicesList.includes(this.fromPluginId);

    if (this.challengeDialog) {
      this.result = true;
    }
    this._store
      .select(fromStore.getWebsitesLoaded)
      .pipe(
        filter((loaded: boolean): boolean => !!loaded),
        switchMap(() => this._store.select(fromStore.getWebsite(this.websiteId)))
      )
      .subscribe((website: Website) => {
        if ( website) {
          this.website = website;
        }
      });
  }

  public getElementorPlugin(): void {
    this._productService.getWordpressPlugins(this.websiteId, Config.elementorPluginSlug)
      .pipe(filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe((response: DbResponse): void => {
        if (response.success) {
          this.elementorPlugin = response.data.filter(plugin => plugin.slug === Config.elementorPluginSlug)[0];
        }
      });
  }

  public openMessangerDialog(): void {
    FB.CustomerChat.showDialog();
    this.close();
  }

  public letsExplore(): void {
    if (this.userSubscription && this.userSubscription.subscriptionId === this.UserSubscriptionIds.TRIAL) {
      this.close();
      return;
    }
    else if ( this.fromPremiumPlugin ) {
      this._router.navigate([`/websites/${this.website.id}/plugins`]);
    }
    else if (this.website && this.website.isActive && !this.website.isLocalhost && this.currentSubscriptionType && this.website.id && [UserSubscriptionType.ONE_PRODUCT, UserSubscriptionType.PREMIUM].includes(<any>this.currentSubscriptionType)) {
      this._router.navigate([`/websites/${this.website.id}/plugins`], { queryParams: {website_connected: true} });
    }
    else if (this.fromPluginId && this.currentSubscriptionType === UserSubscriptionType.FREE) {
      const productsList = [69, 97, 99, 93, 43];
      const performanceProductsList = [95, 101];
      if (productsList.includes(this.fromPluginId)) {
        this.enableServicePlugin(this.website, fromStore.getWebsiteImageOptimizerPlugin(this.website.id));
        this._router.navigate(['/websites/' + this.website.id + '/image-optimizer']);
      }
      else if ( this.fromPluginId === 167 ) {
        this.enableServicePlugin(this.website, fromStore.getWebsiteSecurityPlugin(this.website.id));
        this._router.navigate(['/websites/' + this.website.id + '/security']);
      }
      else if ( this.fromPluginId === 71 ) {
        this.enableServicePlugin(this.website, fromStore.getWebsiteBackupPlugin(this.website.id));
        this._router.navigate(['/websites/' + this.website.id + '/backup']);
      }
      else if ( this.fromPluginId === 171 || performanceProductsList.includes(this.fromPluginId)) {
        this._store.dispatch(new fromStore.RunPerformanceTest(this.website.id, null));
        this._router.navigate(['/websites/' + this.website.id + '/performance/history']);
      }
      else if ( this.fromPluginId === 165 ) {
        this.enableServicePlugin(this.website, fromStore.getWebsiteSeoPlugin(this.website.id));
        this._router.navigate(['/websites/' + this.website.id + '/seo/seo-overview']);
      }
    }
    else if (!this.fromPremiumPlugin) {
      this._router.navigate(['/websites/' + this.website.id + '/main']);
    }
    if (!localStorage.getItem('dbScoreTooltipShown')) {
      localStorage.setItem('dbHideScoreTooltip_' + this.website.id, '0');
      localStorage.setItem('dbScoreTooltipShown', '1');
    }
    this.close();
  }

  public enableServicePlugin(website, enableService, enableElementorPlugin: boolean = false): void {
    this._store.select(fromStore.getWebsitePluginsLoaded(website.id))
      .pipe(

        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(enableService)),
        first()
      )
      .subscribe((servicePlugin: Product) => {
        if (servicePlugin) {
          if ( enableElementorPlugin ) {
            this._store.dispatch(new fromStore.InitWebsiteProductAction({
              website: website,
              products: [servicePlugin, this.elementorPlugin],
              action: ActivityAction.INSTALL_ACTIVATE,
              network: 1
            }));
          }
          else {
            if (!servicePlugin.paidVersionInstalled) {
              this._store.dispatch(new fromStore.InitWebsiteProductAction({
                website: website,
                products: [servicePlugin],
                action: ActivityAction.INSTALL_ACTIVATE,
                network: 1
              }));
            }
            else if (!servicePlugin.active) {
              this._store.dispatch(new fromStore.InitWebsiteProductAction({
                website: website,
                products: [servicePlugin],
                action: ActivityAction.ACTIVATE,
                network: 1
              }));
            }
          }
        }
      });
  }
}
